import EVALUATION_STATUSES from "../constants/evaluationStatuses.constant";

function BeautifyStatusFilter() {
    return (input) => {
        switch(input) {
            case(EVALUATION_STATUSES.CERTIFIED):
                return "Certified";
            case(EVALUATION_STATUSES.EXPIRED):
                return "Expired";
            case(EVALUATION_STATUSES.FINISHED):
                return "Finished";
            case(EVALUATION_STATUSES.NOT_CERTIFIED):
                return "Not Certified";
            case(EVALUATION_STATUSES.NOT_STARTED):
                return "Not Started";
            case(EVALUATION_STATUSES.PENDING):
                return "Pending";
            case(EVALUATION_STATUSES.REMOVED):
                return "Removed";
        }
        return input.replace("_", " ");
    };
}

export default BeautifyStatusFilter;



// WEBPACK FOOTER //
// ./src/app/filters/beautifyStatus.js